<template>
    <div class="newsItem">
        <el-row :gutter="20">
            <el-col :span="14" :offset="5" class="hidden-sm-and-down phone">
                <div class="newsItemInfo">
                    <div class="newsImg">
                        <img :src="`${newsData.img_url}`" width="100%" height="100%" alt="" srcset="">
                    </div>
                    <div class="info">
                        <div class="title">{{$i18n.locale=='zh'? newsData.title_zh:newsData.title_en }}</div>
                        <div class="newsBrand">{{$i18n.locale=='zh'? newsData.source_zh:newsData.source_en}}</div>
                        <div class="date">{{newsData.date}}</div>
                        <div class="more">. . . . . .</div>
                    </div>
                </div>
            </el-col>
            <el-col :span="14" :offset="5" class="hidden-md-and-up pc">
                <div class="newsItemInfo">
                    <div class="newsImg">
                        <img :src="`${newsData.img_url}`" width="100%" height="100%" alt="" srcset="">
                    </div>
                    <div class="info">
                        <div class="title">{{$i18n.locale=='zh'? newsData.title_zh:newsData.title_en }}</div>
                        <div class="newsBrand">{{$i18n.locale=='zh'? newsData.source_zh:newsData.source_en}}</div>
                        <div class="date">{{newsData.date}}</div>
                        <div class="more">. . . . . .</div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="14" :offset="5">
                <div class="lines"></div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    props:['newsData'],
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
        }
    },
}
</script>
<style lang="less">
.newsItem{
    width: 100%;
    margin-bottom: 2rem;
    cursor: pointer;
    .phone{
        .newsItemInfo{
            display: flex;
            flex-wrap:wrap;
            .newsImg{
                box-shadow: 0pt 3pt 8pt rgba(0, 0, 0, 0.3);
                width: 40%;
                img{
                    display: block;
                }
            }
            .info{
                width: 60%;
                
            }
        }
        margin-bottom: 2rem;
    }
    .title{
        color: #017CA4;
        font-size: 1.1rem;
        margin-left: 2rem;
        font-weight: bold;
        width: 95%;
        text-overflow:ellipsis;
        overflow:hidden;
        white-space:nowrap; 
        margin-bottom: 1rem;
    }
    .newsBrand{
        margin-left: 2rem;
        background-color: rgba(1, 123, 164, 0.68);
        color: #fff;
        display: inline;
        padding: 5px 20px;
        font-size: 0.6rem;
        border-radius: 5rem;
    }
    .date{
        margin-left: 2rem;
        color: #727272;
        margin-top: 1rem;
        font-size: 0.6rem;
        margin-bottom: 0.3rem;
    }
    .more{
        margin-left: 2rem;
        color: #727272; 
        font-size: 0.8rem;
        margin-bottom: 1rem;                   
    }
    .pc{
        .newsItemInfo{
            display: flex;
            flex-wrap:wrap;
            .newsImg{
                box-shadow: 0pt 3pt 8pt rgba(0, 0, 0, 0.3);
                width: 100%;
                img{
                    display: block;
                }
            }
            .info{
                width: 100%;
                min-height: 200px;
                margin-top: 1rem;
                margin-bottom: 1rem;
            }
        }
    }
    
    .lines{
        width: 100%;
        border-bottom: 1px solid #BFBFBF;
    }
}
</style>

